// IMG CAROUSELS
$(function() {
    $('.carousel').slick({
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-caret-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-caret-right"></i></button>'
    });
    $('.recipe-img-carousel').slick({
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-caret-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-caret-right"></i></button>',
    });
    $('.hero-carousel').slick({
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-caret-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-caret-right"></i></button>',
        autoplay: true,
        autoplaySpeed: 6000,
        fade: true,
        speed: 800,
        dots: true,
        cssEase: 'ease-out'
    });
});
